import type { Row, TableState } from '@tanstack/react-table';
import type { TFilterValue } from './common';
import type FilterGroup from './Filters/FilterGroup';

// client side filter function if we choose to use the AdvancedFilterV2 on the client
export function advancedFilterFnV2<T>(row: Row<T>, __columnId__: string, filterGroup: FilterGroup): boolean {
  let allAndConditionsMet: boolean = true;
  let someOrConditionsMet: boolean = false;

  if (!filterGroup.hasChildren) return true;

  for (let i = 0; i < filterGroup.children.length; i++) {
    const f = filterGroup.children[i];

    if (f.type === 'group') {
      const isSatisfied = advancedFilterFnV2(row, __columnId__, f);

      if (f.condition === 'and') {
        if (!isSatisfied) {
          allAndConditionsMet = false;
          break;
        } else {
          someOrConditionsMet = true;
        }
      } else {
        if (isSatisfied) {
          someOrConditionsMet = true;
        }
      }
    } else {
      const cellValue = row.getValue(f.columnId) as TFilterValue | undefined;
      const isSatisfied = f.meetsCriteria(cellValue);

      //@ts-expect-error
      if (f.condition === 'and') {
        if (!isSatisfied) {
          allAndConditionsMet = false;
          break;
        } else {
          someOrConditionsMet = true;
        }
      } else {
        if (isSatisfied) {
          someOrConditionsMet = true;
        }
      }
    }
  }

  return allAndConditionsMet && someOrConditionsMet;
}

export interface ReactTableToSearchParamsOptions extends TableState {
  filters?: any;
}

export function reactTableToSearchParams(state: Partial<ReactTableToSearchParamsOptions>) {
  const { pagination, filters } = state;
  const sort = state.sorting?.[0];

  return {
    ...(pagination && {
      limit: pagination.pageSize,
      skip: pagination.pageIndex * pagination.pageSize,
    }),
    ...(sort && {
      sort: { property: sort.id, order: sort.desc === true ? 'desc' : 'asc' },
    }),
    ...(filters && { filters }),
  };
}
